import { LoginSource } from '@app/modules/trading/modules/profile/components/personal-details/interfaces/personal-details.enum';
import {  SocialLogin } from './auth.interfaces';
import { SocialLoginProvider } from './auth.structs';

export const SOCIAL_LOGINS: SocialLogin[] = [
    {
        provider: SocialLoginProvider.GOOGLE,
        image: 'google.svg'
    },
    {
        provider: SocialLoginProvider.SHARE_INDIA,
        image: 'shareIndiaLogo.svg',
        fixed: true
    }
    // ,
    // {
    //     provider: SocialLoginProvider.FACEBOOK,
    //     image: 'facebook.svg'
    // }
];


export enum OTPType {
    EmailOTPType = "email",
    MobileOTPType = "mobile"
}

export enum ButtonText {
    Proceed = 'Proceed',
    Resend = 'Resend'
}

export const VENDOR_SOURCE_ALLOWED = {
    'UtradePro':LoginSource.SHARE_INDIA,
    'Swastika': LoginSource.SWASTIKA,
    'Mastertrust': LoginSource.MASTERTRUST,
    'Pesb': LoginSource.PESB,
    'StratX': LoginSource.STRATX,
    'Operator': LoginSource.SHARE_INDIA
}

export const crmUtmFieldsArray = ['utm_campaign', 'utm_source', 'utm_medium','utm_content'];

export enum FormType {
    LOGIN = 'login',
    SUPERADMIN = 'superadmin',
    OTP_VERIFICATION = 'otp-verification',
    BROKER_LOGIN = 'broker-login'
}

export enum LoginType {
    PHONE = 'phone',
    EMAIL = 'email'
}

export enum Broker {
    SHARE_INDIA = 'shareIndia',
    ZERODHA = 'zerodha',
    ANGEL_ONE = 'angelone',
    KOTAK = 'kotak',
    UPSTOX = 'upstox',
    GROWW = 'groww',
    DHAN = 'dhan',
    MASTER_TRUST = 'mastertrust',
    MOTILAL_OSWAL = 'motilaloswal',
    FYERS = 'fyers',
    AXIS_DIRECT = 'axisdirect',
    HDFC = 'hdfc',
    SBICAP = 'sbicap',
    FIVE_PAISA = '5paisa',
    SHARE_KHAN = 'sharekhan',
    ANAND_RATHI = 'anandrathi',
    ICICI = 'icici',
    IIFL = 'iifl'
}

export enum UserBlockedReason {
    WRONG_OTP_BREACH = 'wrong otp breach',
    RESEND_OTP_BREACH = 'resend otp breach',
}